export default function CustomInput({
  label,
  value,
  onChange,
  allowedChars,         
  fullWidth = true,
  placeholder = "",
  className = "",
  inGroup = false,        
  ...props
}) {
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (!allowedChars || allowedChars.test(inputValue)) {
      onChange?.(e);
    }
  };

  if (inGroup) {
    return (
      <input
        {...props}
        className={`form-control ${className}`}
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        inputMode="decimal"
        pattern="[0-9.]*"
      />
    );
  }
  return (
    <div className={`${fullWidth ? "w-100" : ""} ${className}`}>
      {label && <label className="form-label">{label}</label>}
      <input
        {...props}
        className="form-control"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        inputMode="decimal"
        pattern="[0-9.]*"
        readOnly={props.readOnly}
      />
    </div>
  );
}